import { FC, useMemo } from 'react';
import { Filter, GetCallsRequest } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2/call_intelligence.pb';
import { Sentiment, SortType } from '@weave/schema-gen-ts/dist/shared/call-intelligence/enums.pb';
import dayjs from 'dayjs';
import { CallIntelTypes, CallIntelUtils } from '@frontend/api-call-intel';
import { useTranslation } from '@frontend/i18n';
import { API_DATE_FORMAT } from '../../constants';
import { CallListCard } from '../call-list-card';

const PAGE_LIMIT = 10;
const SORT_ORDER = SortType.SORT_DESC;

export const CallList: FC<{ locationIds: string[]; showLocationChip: boolean }> = ({
  locationIds = [],
  showLocationChip = false,
}) => {
  const { t } = useTranslation('callIntelDashboardWidgets');

  const callRequest = useMemo<GetCallsRequest>(() => {
    const commonFilter = CallIntelUtils.generateCommonFilterPayload({
      startDate: dayjs(CallIntelUtils.defaultDateRangeMap['this-week'].startDate).format(API_DATE_FORMAT),
      endDate: dayjs(CallIntelUtils.defaultDateRangeMap['this-week'].endDate).format(API_DATE_FORMAT),
      locations: locationIds,
    }).filter;

    const filterMap: Record<number, Filter> = {
      [CallIntelTypes.FilterTypeEnum.FILTER_BY_SENTIMENT]: {
        sentiments: [Sentiment.SENTIMENT_NEGATIVE],
      },
      [CallIntelTypes.FilterTypeEnum.FILTER_BY_CALL_STATUS]: {
        callStatus: [CallIntelTypes.CallStatus.CALL_STATUS_COMPLETE],
      },
    };

    if (commonFilter[CallIntelTypes.FilterTypeEnum.FILTER_BY_DATE_RANGE]) {
      filterMap[CallIntelTypes.FilterTypeEnum.FILTER_BY_DATE_RANGE] =
        commonFilter[CallIntelTypes.FilterTypeEnum.FILTER_BY_DATE_RANGE];
    }

    if (commonFilter[CallIntelTypes.FilterTypeEnum.FILTER_BY_LOCATION]) {
      filterMap[CallIntelTypes.FilterTypeEnum.FILTER_BY_LOCATION] =
        commonFilter[CallIntelTypes.FilterTypeEnum.FILTER_BY_LOCATION];
    }

    return {
      limit: PAGE_LIMIT,
      sortType: SORT_ORDER,
      filter: filterMap,
    };
  }, [locationIds]);

  return (
    <CallListCard
      request={callRequest}
      showLocationChip={showLocationChip}
      emptyState={{
        header: t('No Unhappy Calls'),
        type: 'no_calls_made',
      }}
    />
  );
};
